import { render, staticRenderFns } from "./IconNewspaperSolid.vue?vue&type=template&id=41c640a4"
import script from "./IconNewspaperSolid.vue?vue&type=script&lang=js"
export * from "./IconNewspaperSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports